<template>
  <div class="stat">
    <div class="stat-icon">
      <mdicon v-if="icon" class="icon" size="50" :name="icon" />
    </div>
    <div class="stat-info">
      <span class="stat-title">{{ title }}</span>
      <span class="stat-value">{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stat",
  props: ["title", "value", "icon", "color"],
  computed: {
    style() {
      return `color: ${this.color || "#aaa"}`;
    },
  },
};
</script>

<style>
.stat {
  flex: 1;
  display: flex;
  background-color: #fff;
  color: #545454;
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.stat-icon {
  display: flex;
  align-items: center;
}

.stat-icon .icon {
  font-size: 2rem;
}

.stat-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.stat-title {
  font-size: 1rem;
  font-weight: bold;
}

.stat-value {
  font-weight: bold;
  font-size: 1rem;
}
</style>